import {find} from 'lodash';
import set from 'lodash/set';
import React, {
  CSSProperties,
  FunctionComponent,
  useEffect,
  useState,
} from 'react';
import {useDispatch} from 'react-redux';
import swal from 'sweetalert2';
import {NewsPostEditor} from '../../components/NewsPostEditor';
import {getEndpoint, getHeaders} from '../../helpers/endpoint';
import {getParameterByName} from '../../helpers/location';
import {INewsFeed} from '../../types/newsFeed';
import {getNewsFeed} from '../NewsFeedList';

const styles: Record<string, CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'row',
    margin: 16,
  },
  titleContainer: {
    display: 'flex',
    height: 43,
    backgroundColor: 'white',
    width: '100%',
    alignItems: 'center',
    fontSize: 18,
    paddingLeft: 16,
  },
  flex1: {
    flex: 1,
  },
  flex2: {
    flex: 2,
  },
  saveButton: {
    height: 48,
    width: 150,
    color: '#4054CC',
    borderRadius: 4,
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: '#4054CC',
    fontWeight: 'bold',
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 32,
  },
  disabledButton: {
    height: 48,
    width: 150,
    color: 'white',
    borderRadius: 4,
    backgroundColor: '#959DAF',
    fontWeight: 'bold',
    borderWidth: 0,
  },
};

export const createNewsPost = (
  payload: INewsFeed,
  onSuccess: (response: INewsFeed) => void,
) => {
  return (_dispatch, getState) => {
    return fetch(getEndpoint('createNewsPost'), {
      method: 'POST',
      headers: getHeaders(getState().authentication),
      body: JSON.stringify({
        ...payload,
        createdAt: undefined,
        id: undefined,
        status: undefined,
        type: undefined,
        updatedAt: undefined,
      }),
    })
      .then(response => response.json())
      .then(data => {
        if (data.error) {
          swal({
            title: `Oops...`,
            type: 'error',
            html: `Something went wrong !<br/>${data.message}<br/>`,
          });
        } else {
          onSuccess(data);
        }
      })
      .catch(error => {});
  };
};

export const CreateNewsPost: FunctionComponent = ({history}) => {
  const dispatch = useDispatch();
  const [newsPost, setNewsPost] = useState<INewsFeed>({});
  const onChange = (key: string, value: string | number | undefined) => {
    setNewsPost({...set(newsPost, key, value)});
  };

  useEffect(() => {
    if (getParameterByName('newsPostId', window.location.href)) {
      dispatch(
        getNewsFeed(response =>
          setNewsPost(
            // @ts-ignore
            find(response, {
              id: getParameterByName('newsPostId', window.location.href),
            }) || {},
          ),
        ),
      );
    }
  }, []);

  const onSubmit = () => {
    const onSuccess = (response: INewsFeed) => {
      history.push(`/news-feed/update/${response.id}`);
    };
    if (newsPost.name) {
      dispatch(createNewsPost(newsPost, onSuccess));
    }
  };

  let disabled = false;
  if (!newsPost.name) disabled = true;
  if (newsPost.localization) {
    Object.keys(newsPost.localization).forEach(key => {
      if (newsPost.localization && newsPost.localization[key]) {
        if (newsPost.localization[key].socialEmbed) {
          Object.keys(newsPost.localization[key].socialEmbed || {}).forEach(
            socialKey => {
              if (
                newsPost.localization[key].socialEmbed[socialKey] &&
                socialKey !== 'youtube'
              ) {
                if (!newsPost.localization[key].socialEmbed[socialKey].html) {
                  disabled = true;
                }
              }
            },
          );
        }
      }
    });
  }

  return (
    <div style={styles.container}>
      <div style={styles.flex2}>
        <div style={styles.titleContainer}>Create news post</div>
        <NewsPostEditor onChange={onChange} data={newsPost} isCreation />
        <div style={styles.buttonContainer}>
          <button
            disabled={disabled}
            style={disabled ? styles.disabledButton : styles.saveButton}
            onClick={onSubmit}>
            Sauvegarder
          </button>
          <span style={{marginLeft: 8, color: 'red'}}>*</span>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/CreateNewsPost/index.tsx